/*
 --------------------------------------------------
 --------------------------------------------------
     Table Name : LU_AppFeatures
 --------------------------------------------------
 --------------------------------------------------
 DO NOT MODIFY MANUALLY
 --------------------------------------------------
 -------------------------------------------------- */

export const APPLICATION_INTEGRATION_MODULE = 'Application_Integration_Module' as const;
export const COURSES_MODULE = 'Courses_Module' as const;
export const EXAM_SYSTEM_MODULE = 'Exam_System_Module' as const;
export const LAERDAL_INTEGRATION_MODULE = 'Laerdal_Integration_Module' as const;
export const LIVE_MONITORS = 'Live_Monitors' as const;
export const MONITOR_CONTROLS = 'Monitor_Controls' as const;
export const NOTIFICATIONS_MODULE = 'Notifications_Module' as const;
export const PARTICIPANT_DRIVEN_LEARNING = 'Participant_Driven_Learning' as const;
export const REMOTE_EXAMS = 'Remote_Exams' as const;
export const RESERVATION_MODULE = 'Reservation_Module' as const;
export const SHOW_HIDDEN_FEATURES = 'Show_Hidden_Features' as const;
export const SIMULATORS_MODULE = 'Simulators_Module' as const;

const LU_AppFeatures = {
    APPLICATION_INTEGRATION_MODULE,
    COURSES_MODULE,
    EXAM_SYSTEM_MODULE,
    LAERDAL_INTEGRATION_MODULE,
    LIVE_MONITORS,
    MONITOR_CONTROLS,
    NOTIFICATIONS_MODULE,
    PARTICIPANT_DRIVEN_LEARNING,
    REMOTE_EXAMS,
    RESERVATION_MODULE,
    SHOW_HIDDEN_FEATURES,
    SIMULATORS_MODULE
} as const;

export type AppFeature = typeof LU_AppFeatures[keyof typeof LU_AppFeatures];

export default LU_AppFeatures;
